var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          staticClass: "scroll",
          class: { minHeigth: !_vm.readMode },
          attrs: {
            title:
              _vm.readMode && !_vm.observers.length
                ? "No hay observadores registrados"
                : "Observadores"
          }
        },
        [
          _c(
            "form",
            {
              attrs: { "data-vv-scope": "observer-form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              !_vm.readOnly
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-11" },
                      [
                        _c("ListUser", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "w-100 mb-0",
                          attrs: {
                            autocomplete: "",
                            label: "Nombre del observador",
                            name: "user",
                            "data-vv-as": "usuario",
                            danger: _vm.errors.has("observer-form.user"),
                            "danger-text": _vm.errors.first(
                              "observer-form.user"
                            )
                          },
                          on: {
                            "full-user": function($event) {
                              _vm.observer = $event
                            }
                          },
                          model: {
                            value: _vm.user,
                            callback: function($$v) {
                              _vm.user = $$v
                            },
                            expression: "user"
                          }
                        }),
                        _vm.repeated
                          ? _c("small", { staticClass: "text-danger mb-5" }, [
                              _vm._v("Usuario ya elegido")
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3 mt-5" },
                      [
                        _c(
                          "vs-checkbox",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value:
                                  "Marca si quiere recibir una notificación",
                                expression:
                                  "'Marca si quiere recibir una notificación'"
                              }
                            ],
                            staticClass: "mt-5 w-100",
                            attrs: {
                              "data-cy": "notification",
                              color: "primary"
                            },
                            model: {
                              value: _vm.notification,
                              callback: function($$v) {
                                _vm.notification = $$v
                              },
                              expression: "notification"
                            }
                          },
                          [_vm._v(" Notificación ")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-1 mt-3" },
                      [
                        _c("vs-icon", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Agregar observador",
                              expression: "'Agregar observador'"
                            }
                          ],
                          staticClass: "mt-5 w-100 cursor-pointer",
                          attrs: {
                            icon: "add_circle_outline",
                            size: "medium",
                            color: "success",
                            "data-cy": "add-observer"
                          },
                          on: { click: _vm.addObserver }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row mt-5" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _vm.observers.length
                      ? _c("b-table", {
                          staticClass: "text-center",
                          attrs: {
                            small: "",
                            items: _vm.observers,
                            fields: _vm.fields
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(notificar)",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    item.notificar
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success"
                                          },
                                          [_vm._v("Si")]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-warning"
                                          },
                                          [_vm._v("No")]
                                        )
                                  ]
                                }
                              },
                              {
                                key: "cell(action)",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    !_vm.readOnly
                                      ? _c("vs-icon", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: "Eliminar observador",
                                              expression:
                                                "'Eliminar observador'"
                                            }
                                          ],
                                          staticClass:
                                            "mt-5 w-100 cursor-pointer",
                                          attrs: {
                                            icon: "remove_circle_outline",
                                            size: "medium",
                                            color: "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeObserver(
                                                item.observador
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            259652975
                          )
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }